/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DiscountType } from './discountType';


export interface TransactionDiscountInfo { 
    discountId?: number;
    discountCodes?: string | null;
    discountPriceType?: DiscountType;
    discountRateUsed?: number;
    waiveServiceFee?: boolean;
    waiveTax?: boolean;
}
export namespace TransactionDiscountInfo {
}


